import React, {useState, useEffect, useCallback} from 'react';
// import SortableTree from 'react-sortable-tree';
import { SortableTreeWithoutDndContext as SortableTree } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import './IntentTree.css';
import DragAndDrop from './DragAndDrop';
import * as TreeAcross from './Common/TreeAcross';

function App(props) {

  var treeVIn = props.tree;
  var selectPositionWithSubAction = props.selectPositionWithSubAction;

  const formTree = useCallback((tree)=>{

    function formT(treeV, subtitle, levels){
      var title = treeV.v[1].v;
      var labels = treeV.v[4].v;
      var expression = treeV.v[8];
      var variable = treeV.v[10];
      var erlangTypeID = treeV.v[0].v;
      var typeVariables = treeV.v[5];
      var children = [];
      var notes = false;
      if (variable.t === "atom"){
        if (variable.v === "null"){
          children = treeV.v[2].v.filter((aChild, index)=>{
            var erlangTypeID1 = aChild.v[0].v;
            var expression = aChild.v[8];
            var p = TreeAcross.isAnAddVariable(erlangTypeID1, expression);
            if (p){
              console.log(aChild);
              return false;
            }
            return true;
          }).map((aChild, index)=>{
            var thisSubtitle = TreeAcross.getSubtitleFromLabels(index, labels);
            return formT(aChild, thisSubtitle, levels.concat(+index));
          });

        }
      }else if (variable.t === "tuple"){
        if(variable.v[0].v === "v"){
          title = "Variable : " + variable.v[5].v;
          notes = variable;
        }
      }
      return {title, subtitle, children, erlangTypeID, expression, typeVariables, selfPath:levels, notes, expanded:true};
    }

    return formT(tree, "", []);
  }, []);


  function countTree(treeV){
    var total = 1;
    treeV.children.map((aChild, index)=>{
      var p = countTree(aChild);
      total += p;
      return null;
    })        
    return total;
  }

  var treeDataIn = [formTree(treeVIn)];
  const [treeData, setTreeData] = useState(treeDataIn);

  useEffect(() => {
    var newTree = [formTree(treeVIn)];
    setTreeData(newTree);
    // setArrayOfHeights(0);
  }, [treeVIn, formTree]);

  function clickSelectWithChoice(subaction, extendedNode){
    return function(e){
      selectPositionWithSubAction(subaction, extendedNode.node.selfPath, "", 0);
    }
  }

  function replaceWithVariable(nos, extendedNode){
    return function(e){
      selectPositionWithSubAction("replaceWithVariable", extendedNode.node.selfPath, nos);
    }
  }

  function changeVariableName(originalName, extendedNode, variableNos){
    return function(e){
      var p = window.prompt("New Name", originalName)
      if (p){
        selectPositionWithSubAction("changeVariableName", extendedNode.node.selfPath, p, variableNos);
      }
    }
  }

  function setAsVariable(extendedNode){
    return function(e){
      var p = window.prompt("Name of Variable", "");
      if (p){
        selectPositionWithSubAction("setAsVariable", extendedNode.node.selfPath, p, -1);
      }
    }
  }

  function typeVariablesAreTheSame(A,B){
    if (A.t === "list" && B.t === "list"){
      if (A.v.length === 0 && B.v.length === 0){
        return true;
      }
    }else if (A.t === "tuple" && B.t === "tuple"){
      if (A.v[0].v === 164 && B.v[0].v === 164){
        var listA = A.v[1].v;
        var listB = B.v[1].v;
        if (listA.length === listB.length){
          for (var i = 0; i < listA.length; i++){
            var itemA = listA[i].v;
            var itemB = listB[i].v;
            if (itemA[1].v === itemB[1].v && itemA[2].v === itemB[2].v){
              return true;
            }

          }
        }
      }
    }
    return false;
    // if (A.t === B.t){

    // }
  }

  function findAllVariablesOfType(tree, tgt, typeVariables, array){
    var variable = tree.v[10];
    if (variable.t === "tuple"){
      var erlangTypeID = variable.v[2].v;
      var typeVariablesHere = variable.v[3];
      if(erlangTypeID === tgt){
        var p = typeVariablesAreTheSame(typeVariables, typeVariablesHere);
        if (p){
          array.push({nos:variable.v[1].v, title:variable.v[5].v});
        }
      }   
    }
    var children = tree.v[2].v;
    children.map((aChild, index)=>{
      findAllVariablesOfType(aChild, tgt, typeVariables, array);
      return null;
    });
  }

  function buttons(extendedNode){
    var notes = extendedNode.node.notes;
    var erlangTypeID = extendedNode.node.erlangTypeID;
    var typeVariables = extendedNode.node.typeVariables;
      var expression = extendedNode.node.expression;

    if (!TreeAcross.isValidVariableOrReusable(erlangTypeID, expression)){
      return [];
    }

    var selfPath = extendedNode.node.selfPath;
    if (selfPath.length === 0){
      return [];
    }

    var currentVariableNos = -1;
    var pieces = [];
    if (notes){
      var isSelfDeclared = notes.v[4].v;
      if (isSelfDeclared){
        pieces.push(<button onClick={clickSelectWithChoice("removeAsVariable", extendedNode)}>Remove Variable</button>)
//          
      }
      currentVariableNos = notes.v[1].v;
      pieces.push(<button onClick={changeVariableName(notes.v[5].v, extendedNode, notes.v[1].v)}>Rename Variable</button>)
//
    }else{
      pieces.push(<button onClick={setAsVariable(extendedNode)}>Set as Variable</button>);
    }
//      

    var variablesOfType = [];
    findAllVariablesOfType(treeVIn, erlangTypeID, typeVariables, variablesOfType);
    var variablesOfTypeRemoveOwnNos = variablesOfType.filter((aVariable, index)=>{
      return aVariable.nos !== currentVariableNos;
    });
    variablesOfTypeRemoveOwnNos.filter((aVariable, index)=>{
      for (var i = 0; i < +index; i++){
        if (variablesOfTypeRemoveOwnNos[i].nos === aVariable.nos){
          return false;
        }
      }
      return true;
    }).map((aVariable, index)=>{
      pieces.push(<button onClick={replaceWithVariable(aVariable.nos, extendedNode)}>Replace with Variable {aVariable.title}</button>)
      return null;
    });

//
    return pieces;


  }

  function generateProps(extendedNode){
    // var path = extendedNode.node.selfPath;
    var p = {title: extendedNode.node.title, subtitle:extendedNode.node.subtitle};

    var buttons1 = buttons(extendedNode);
    if (buttons1){
      p.buttons = buttons1;
    }
    return p;
  }

  var numberOfRows = countTree(treeData[0]);

  var inside = <DragAndDrop><SortableTree
              treeData={treeData}
              onChange={treeData => setTreeData(treeData)}
              canDrag={false}
              generateNodeProps={generateProps}
            /></DragAndDrop>
//  
    return <div style={{ height: 10 + numberOfRows * 62 , textAlign:"left"}} >
        {inside}
          </div>

  
    //
}


export default App;

